<template>
  
  <div class="note">
    <div class="icon">
      <md-icon class="good"         v-if="     _status == 'good'">check_circle</md-icon>
      <md-icon class="neutral"      v-else-if="_status == 'neutral'">error</md-icon>
      <md-icon class="bad"          v-else-if="_status == 'bad'">cancel</md-icon>
      <md-icon class="greyed"          v-else-if="_status == 'greyed'">cancel</md-icon>
      <md-icon class="information"  v-else-if="_status == 'info'">info</md-icon>
      <md-icon class="information"  v-else>info</md-icon>
    </div>

    <slot></slot>
  </div>

</template>
<script>
export default {
  name: "note-view",
  props: {
    status: {
      type: String,
      default: "information",
    },
  },
  computed: {
    _status() {
      let s = this.status.toLowerCase();
      switch(s){
        case 'accept':  s = 'good'; break;
        case 'note':    s = 'info'; break;
        case 'warning': s = 'neutral'; break;
        case 'error':   s = 'bad'; break;
        case 'decline': s = 'bad'; break;
        case 'warning_greyed': s = 'greyed'; break;
      }
      return s;
    },
  },
};
</script>
<style scoped lang="scss">
  @import "@/assets/scss/theme.scss";
  
  .good       { color: $color-good !important; }
  .neutral    { color: $color-neutral !important; }
  .bad        { color: $color-bad !important; }
  .information{ color: $color-information !important; }
  .greyed{ color: $color-grey !important; }

  .note {

    & > *{
      display: inline-block;
    }

    & .icon{
      width: 30px;
    }
  }
  

</style>
